var _defs, _clipPath, _g, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMagazineLogoEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 287.9 44.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 8.1h128.3v28.2H0z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 8.1h128.3v28.2H0z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M0 8.1h128.3v28.2H0z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M0 8.1h128.3v28.2H0z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M0 8.1h128.3v28.2H0z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M0 8.1h128.3v28.2H0z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M0 8.1h128.3v28.2H0z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M0 8.1h128.3v28.2H0z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "q",
    d: "M0 8.1h128.3v28.2H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f",
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h",
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j",
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l",
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#k"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n",
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#m"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p",
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#o"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r",
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#q"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.7 14.7c0-.5-.1-1-.3-1.4-.4-.6-1.1-1.1-1.9-1.1-1 0-1.9.6-2.4 1.5-.2.3-.3.6-.3 1l-.3 3H9c3.7 0 3.7-3 3.7-3m5.3 4.9c-.3-.1-.6-.2-1-.2H2.7c-.5 0-1 .1-1.4.4-.7.4-1.2 1.2-1.3 2-.1 1 .4 1.9 1.3 2.3.3.1.6.2.9.2h4.7L6.6 29c0 .3 0 .7.1 1 .3.9 1.1 1.5 2.1 1.5s1.9-.6 2.3-1.4c.2-.3.3-.6.3-1l.4-4.7h4.7c.3 0 .7-.1 1-.2.9-.4 1.6-1.2 1.7-2.3.1-1-.4-1.9-1.2-2.3m17.8 11.3c-1 .6-2.2.9-3.7.9h-5.8l.6-7.2h6c1.6 0 2.8.1 3.5.7.7.7 1 1.5.9 2.6-.1 1.4-.6 2.4-1.5 3m-7.9-18.3h4.5c1.2 0 2.2.3 2.9.9.7.6 1 1.4.9 2.5-.1 1.3-.6 2.3-1.3 2.8-.8.6-1.7.9-2.8.9h-4.8l.6-7.1zm10.3 8.7c2-1.2 3.1-3.1 3.4-5.9.2-2.4-.5-4.2-2.1-5.5C37.9 8.7 36 8 33.7 8h-7.6c-.5 0-1 .2-1.4.4-.3.2-.5.4-.7.6-.4.4-.6 1-.7 1.5l-2 23c-.1.6.1 1.2.5 1.6.1.2.3.4.5.5.4.3.8.4 1.4.4h9.1c2.5 0 4.8-.7 6.7-1.9 2-1.3 3.1-3.3 3.3-5.8.2-1.9-.2-3.5-1.1-4.8-.9-.9-2-1.7-3.5-2.2M55 31.6c-1.1.6-2.2.9-3.3.9-.9 0-1.7-.2-2.3-.6-.5-.4-.8-.9-.7-1.5.2-1.8 3.6-2.5 6.6-2.7l-.3 3.9zm-1.3-14.9c-1.8 0-3.6.3-5.3 1-1.6.6-2.5 1.5-2.6 2.4 0 .5.1 1 .4 1.3.3.4.8.5 1.3.5.2 0 .7-.1 2.2-.7 1.1-.5 2.2-.7 3.3-.7s1.8.3 2.3.9c.4.5.5 1.3.4 2.4v.1c-3.4.3-5.8.7-7.5 1.4-2.6 1-4 2.7-4.2 5-.2 1.8.4 3.3 1.6 4.3 1.2 1 2.7 1.5 4.5 1.5 1.9 0 3.5-.3 4.9-1 .4.6 1 1 1.9 1 .7 0 1.3-.2 1.8-.7.5-.5.8-1 .9-1.7l.9-9.9c.2-2.2-.2-3.9-1.2-5.1-1.1-1.3-3-2-5.6-2m20.2 13.4C72.7 31.4 71.1 32 69 32c-.9 0-1.6 0-2.2-.1l.9-10.4c1-.4 2.1-.7 3.2-.7 1.4 0 2.5.5 3.3 1.4.9 1 1.2 2.4 1.1 4.1s-.6 2.9-1.4 3.8m-1.8-13.4c-1.4 0-2.7.2-4 .7l.6-6.9c0-.4 0-.7-.1-1-.3-.8-1.1-1.4-2.1-1.4-.8 0-1.6.4-2.1 1.1-.3.4-.5.8-.5 1.4l-2 22.7c-.1 1.5.5 2.4 2 2.7 1.1.2 2.6.3 4.4.3 4 0 7.1-1.1 9.2-3.3 1.6-1.7 2.6-3.8 2.8-6.4.3-2.9-.4-5.3-1.8-7.1-1.6-1.9-3.7-2.8-6.4-2.8m21.6 13.4c-1.2 1.3-2.8 1.9-4.9 1.9-.9 0-1.6 0-2.1-.1l.9-10.4c1-.4 2.1-.7 3.2-.7 1.4 0 2.5.5 3.3 1.4.9 1 1.2 2.4 1.1 4.1-.2 1.7-.6 2.9-1.5 3.8M92 16.7c-1.4 0-2.7.2-4 .7l.6-6.9c0-.4 0-.7-.1-1-.3-.8-1.1-1.4-2.1-1.4-.8 0-1.6.4-2.1 1.1-.3.4-.5.8-.5 1.4l-2 22.7c-.1 1.5.5 2.4 2 2.7 1.1.2 2.6.3 4.4.3 3.9 0 7-1.1 9.2-3.3 1.6-1.7 2.6-3.8 2.8-6.4.3-2.9-.4-5.3-1.8-7.1-1.6-1.9-3.7-2.8-6.4-2.8m14.8 7.7c.2-.9.6-1.7 1.2-2.4.9-.9 2-1.3 3.5-1.3 1.3 0 2.3.4 3 1.2.5.7.8 1.5.8 2.4l-8.5.1zm5.1-7.7c-2.9 0-5.3.9-7.1 2.7-1.9 1.8-3 4.1-3.2 6.8-.3 2.9.4 5.3 2 7.1 1.6 1.9 4 2.9 7.2 2.9 2 0 3.9-.4 5.7-1.1 1.4-.6 2.2-1.4 2.3-2.4 0-.6-.1-1-.4-1.4-.4-.5-1-.8-1.9-.6-.2.1-.4.1-.5.2s-.3.1-.5.2l-.6.3c-1.1.5-2.3.8-3.5.8-1.7 0-3-.5-3.8-1.6-.6-.7-.9-1.6-1-2.6h10.8c.8 0 1.4-.3 1.9-.8s.8-1.1.8-1.9c.2-2.4-.4-4.5-1.8-6.1-1.6-1.6-3.7-2.5-6.4-2.5m16.4-6.2c0-.5-.1-1-.3-1.4-.4-.6-1.1-1.1-1.9-1.1-1 0-1.9.6-2.4 1.5-.2.3-.2.6-.3.9l-2 23.4c0 .3 0 .7.1.9.3.9 1.1 1.5 2.1 1.5s1.9-.6 2.3-1.4c.2-.3.3-.6.3-1l2.1-23.3z",
    clipPath: "url(#r)",
    fill: "#ff790f"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.6 16.7v19.6H158v-15l-5.7 15.1H149l-5.7-15.1v15.1h-4.6V16.7h7.1l4.9 12.9 4.9-12.9h7zm15.9 15.5h-7.9l-1.4 4.1h-4.9l7.3-19.6h6l7.3 19.6h-5l-1.4-4.1zm-1.2-3.5l-2.8-8.1-2.7 8.1h5.5zm26.4-3.9V35c-3.4 1.5-5.4 1.7-7.1 1.7-7.2 0-11.3-4.6-11.3-10.1s4.2-10.1 11-10.1c1.7 0 3.9.3 6.1 1v4.4c-2.5-1-4.5-1.3-5.9-1.3-4.3 0-6.4 2.9-6.4 6 0 3.2 2.2 6 6.4 6 1 0 1.9-.1 3.1-.5v-3.6h-4.2v-3.7h8.3zm15.7 7.4h-7.9l-1.4 4.1h-4.9l7.3-19.6h6l7.3 19.6h-5l-1.4-4.1zm-1.2-3.5l-2.8-8.1-2.7 8.1h5.5zm24.4-11.8l-8.9 15.6h8.7v3.9h-16v-.1l8.7-15.6h-8.5v-3.9h15.9v.1h.1zm6.8-.2v19.6h-4.6V16.7h4.6zm21.5 0v19.6h-5.3L257 23.4v12.9h-4.6V16.7h5.3l8.6 12.6V16.7h4.6zm7.3 3.9v3.8h9.2V28h-9.2v4.4h9.7v3.9h-14.2V16.7h14.2v3.9h-9.7z",
    fill: "#284b7c"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagazineLogoEn);
export default __webpack_public_path__ + "static/media/magazine-logo-en.53f5f496a7d9d4fd569381fbf4163489.svg";
export { ForwardRef as ReactComponent };